import { render } from "./PageLinks.vue?vue&type=template&id=28636b2c"
import script from "./PageLinks.vue?vue&type=script&lang=js"
export * from "./PageLinks.vue?vue&type=script&lang=js"
script.render = render

export default script